import { useGetItemsWithDetailsQuery } from "src/store/slices/item/item.api";
import NoData from "@Components/NoData/NoData";
import { useGiftcardsListing } from "../../context/GiftcardsListingContext";
import GiftCard from "../GiftCard/GiftCard";
import GiftCardSkeleton from "../GiftCardSkeleton/GiftCardSkeleton";
import { useTranslation } from "react-i18next";
import { toLanguage } from "src/i18n/direction";

const GiftcardsListLoading = () => {
  return (
    <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {Array.from({ length: 10 }).map((_, i) => {
        return <GiftCardSkeleton key={`giftcards-${i}`} />;
      })}
    </div>
  );
};

export default function GiftcardsList() {
  const { filters } = useGiftcardsListing();
  const { i18n } = useTranslation();
  const { isFetching, data, error } = useGetItemsWithDetailsQuery({
    moduleType: "GiftCards",
    ...filters,
    Page: 1,
    PageSize: 100000,
    lang: toLanguage(i18n.language),
  });
  if (isFetching) return <GiftcardsListLoading />;
  if (error || !data?.length)
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <NoData />
      </div>
    );

  return (
    <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {data.map((brand) => (
        <GiftCard key={brand.code} {...brand}/>
      ))}
    </div>
  );
}
